import { m as makeForwardRef } from './common-2912ca79.esm.js';

var forwardRef = /*#__PURE__*/makeForwardRef('hover');

export { forwardRef as f };
